import React from "react";
import { useParams } from "react-router";
import VideoForm from "../../../components/admin/videos/VideoForm";
import { useGetVideoQuery } from "../../../features/videos/videosAPI";

function EditVideo() {
  const { id } = useParams();

  const { data: formData, isLoading, isError } = useGetVideoQuery(id);

  let outputForm = null;
  if (isLoading) outputForm = "Loading...";
  if (!isLoading && isError) outputForm = "Something Went Wrong!";
  if (!isLoading && !isError) outputForm = <VideoForm initialData={formData} />;
  return (
    <main
      className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B] mt-8 space-y-6"
      style={{ width: "75%" }}
    >
      <h1 className="mb-10 text-center lws-section-title">Edit Video</h1>

      <div className="max-w-3xl mx-auto">{outputForm}</div>
    </main>
  );
}

export default EditVideo;
